export default {"src":"/_next/static/media/google.084279dc.svg","height":32,"width":32};